import React from 'react';
import { FeatureFlagProvider } from '@bench/ff-client';
import { useTaskManagerContext } from './TaskManagerContext';
import { SplitFeatureFlags } from 'bk-web-app/features';

export const TaskManagerFeatureFlagProvider = ({ children }: React.PropsWithChildren) => {
  const { loggedInPerson } = useTaskManagerContext();

  const config = {
    core: {
      authorizationKey: window.BENCH ? window.BENCH.vendor.split.authorizationKey : '',
      // In task manager, we target by bookkeeperId but Split requires a clientId as the key.
      key: '-1',
    },
  };

  return (
    <FeatureFlagProvider
      config={config}
      // @ts-expect-error - we only pass bookkeeperId here since it's the only valid attribute.
      clientAttributes={{ bookkeeperId: loggedInPerson.id }}
      features={Object.values(SplitFeatureFlags)}
    >
      {children}
    </FeatureFlagProvider>
  );
};
